import { render } from "./TableauClassement.vue?vue&type=template&id=12c86197"
import script from "./TableauClassement.vue?vue&type=script&lang=js"
export * from "./TableauClassement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__